// extracted by css-extract-rspack-plugin
export default {"calendar":"kS7RiC2A0RAdCsSA","grid":"R0LiVed9DkKzDXUU","cell":"kWB2SMQwM9sjdwke","range":"RcswyU7ByBYVJExk","picker":"WwXcdPx0SUXcDV5_","today":"ZmVTWVUF5kgA58iO"};